import React from "react";
import Faq from './Faq';

class FaqCategory extends React.Component {
    
    state= {  
        isOpen: false,
        show:false,
        faqItems: []
    }
    // toggleGroup = () =>{
    //     this.setState({isOpen:this.state.isOpen});
    // }
    toggleShowGroup = () =>{
        let newFaqItem =[];
        if(this.state.faqItems.length == 0){
            newFaqItem= new Array(this.props.data.length);
            newFaqItem = [...newFaqItem].map(item=>(" show "));
        }
        else{
            newFaqItem = [...this.state.faqItems].map(item => ( " show "));
        }
        this.setState({faqItems : newFaqItem, show:true});
    }
    toggleHideGroup = () =>{
        let newFaqItem =[];
        if(this.state.faqItems.length == 0){
            newFaqItem= new Array(this.props.data.length);
            newFaqItem = [...newFaqItem].map(item=>(" collapse "));
        }
        else{
            newFaqItem = [...this.state.faqItems].map(item => ( " collapse "));
        }
        this.setState({faqItems : newFaqItem, show:true});
    }
    toggleInnerItem = (id) =>{
        let newFaqItem =[];
        if(this.state.faqItems.length == 0){
            newFaqItem= new Array(this.props.data.length);
            newFaqItem = [...newFaqItem].map(item=>(" collapse "));
        }
        else{
            newFaqItem = [...this.state.faqItems];
        }
        if(newFaqItem[id] == " show "  )
        {
            newFaqItem[id] = " ";
        }  
        else
        {
            newFaqItem[id] = " show ";
        }
        this.setState({faqItems : newFaqItem, show:true});  
    }

    render() {
        let wp ='';
        if(this.props.data.length > 0)
        {

            wp = this.props.data.map((ord,index) => (
                <Faq  data={ord} toggleInnerItem={()=> this.toggleInnerItem(index)}
                wpId={this.props.wpId} index={index+"_catId"+this.props.catId} catId={this.props.catId}
               //show={this.state.faqItems} />
               isOpen={this.state.isOpen}
               key={"Faq_"+index}
                show={this.state.show ? this.state.faqItems[index] : " collapse "} />
            )) ;
            

        }
    return(
            <div className="col-12"> 
                <div className="row no-gutters">
                    <h3 className="col-7">{this.props.cat}</h3>
                    <div className="buttonDivWrap col-5">
                        <span className="buttonDiv" onClick={this.toggleShowGroup} role="button"> פתח הכל</span>
                        <span className="buttonDiv" onClick={this.toggleHideGroup} role="button"> סגור הכל</span>
                    </div>
                </div>
                {wp}
            </div>
        );
    }
}

export default FaqCategory
//